import React, { useContext } from 'react';
import WouldYouRecommendCollection from '../steps/WouldYouRecommendCollection';
import ThankYou from '../steps/ThankYou';
import LeaveReviewOnSolv from '../steps/ReviewOnSolvCollector';
import { ADD_REVIEW_DIRECT_TO_SOLV } from '../../../constants/index';
import { ReviewContext } from '~/routes/addReview/context';

const RecommendToSolv = () => {
  const context = useContext(ReviewContext)!;

  const {
    booking,
    bookingId,
    error,
    flowState,
    handleRatingChange,
    handleHasRecommendedClinicChange,
    leaveAReview,
    location,
    onStarChange,
    review,
    setFlowState,
    starRating,
    submitReview,
  } = context;

  return (
    <div>
      <WouldYouRecommendCollection
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        handleHasRecommendedClinicChange={handleHasRecommendedClinicChange}
        handleRatingChange={handleRatingChange}
        location={location}
        onStarChange={onStarChange}
        review={review}
        setFlowState={setFlowState}
        starRating={starRating}
        submitReview={submitReview}
      />

      <LeaveReviewOnSolv
        booking={booking}
        bookingId={bookingId}
        error={error}
        flowState={flowState}
        flowType={ADD_REVIEW_DIRECT_TO_SOLV}
        handleRatingChange={handleRatingChange}
        leaveAReview={leaveAReview}
        location={location}
        onStarChange={onStarChange}
        submitReview={submitReview}
      />

      <ThankYou
        booking={booking}
        bookingId={bookingId}
        flowState={flowState}
        starRating={starRating}
      />
    </div>
  );
};

export default RecommendToSolv;
